export default "<div>\r\n    <app-job-posting-form [type]=\"'HM'\"></app-job-posting-form>\r\n</div>"